﻿import { IEmailEntityContract } from './email-entity-contract';

export interface IEmailEntityRequestContract {
    emailTemplateId: number;
    entity: IEmailEntityContract;
}
